export const LAST_SELECTED_SPACE_UID_KEY = "ft_last_selected_space_uid"
export const TAB_SPACE_HEADER = "X-Flextribe-Tab-Space"

const SPACE_UID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const isValidTabSpaceId = (spaceId: string | null): boolean => {
  return typeof spaceId === "string" && SPACE_UID_PATTERN.test(spaceId)
}

export const getSavedTabSpaceId = (): string | null => {
  if (typeof window === "undefined") return null

  const spaceId = window.sessionStorage.getItem(LAST_SELECTED_SPACE_UID_KEY)
  return isValidTabSpaceId(spaceId) ? spaceId : null
}

export const getTabSpaceHeaders = (
  tabSpaceId?: string | null,
): Record<string, string> => {
  const spaceId = isValidTabSpaceId(tabSpaceId ?? null)
    ? tabSpaceId
    : getSavedTabSpaceId()

  return spaceId ? { [TAB_SPACE_HEADER]: spaceId } : {}
}

export const withTabSpaceHeader = (
  options: RequestInit = {},
  enabled: boolean = true,
  tabSpaceId?: string | null,
): RequestInit => {
  if (!enabled) return options

  const headers = new Headers(options.headers ?? {})

  for (const [key, value] of Object.entries(getTabSpaceHeaders(tabSpaceId))) {
    headers.set(key, value)
  }

  const headerRecord: Record<string, string> = {}
  headers.forEach((value, key) => {
    headerRecord[key] = value
  })

  return {
    ...options,
    headers: headerRecord,
  }
}
